import { type Config } from '/@/core/config'

export function parse(cookie: string) {
  return Object.fromEntries(cookie.split(';').map(s => s.trim().split('=')))
}

export function getCookie(cookie: string, key: string) {
  if (!cookie) return null
  const map = parse(cookie)
  return map[key]
}

// Auth is credential-cookie-only in every deployed env — the browser sends
// sidt/slid automatically, and JS never reads them. The dev/e2e path is the
// sole exception: localhost is cross-site to spoak.com so those cookies
// aren't sent, so dev authenticates via a Bearer token derived from the
// local API key instead.
export function getAccessToken(config: Config) {
  if (
    (config.mode === 'development' || config.mode === 'e2e') &&
    config.apiKeys.spoak
  ) {
    return `dev:${config.apiKeys.spoak}`
  }

  return null
}

export function getLoginIdentifier() {
  return null
}
